import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MessageBoxHelper } from '../../components/dialogs/messagebox/messagebox.dialog';
import { TranslateFormatText } from '../../helpers/array.helpers';
import { NotificationHelper } from '../../helpers/notification.helper';
import { MessageBoxButtons } from '../../models/enums/messageboxbuttons.enum';
import { MessageBoxIcon } from '../../models/enums/messageboxicon.enum';
import { MessageBoxResult } from '../../models/enums/messageboxresult.enum';
import { ExternalLibsService } from '../../services/externallibs.service';
import { LayoutService } from '../../services/layout.service';

/**
 * Switches the document-processing library for Excel, PDF and OCR at runtime.
 * The change is persisted and broadcast to every service, so it also applies to workflows
 * running in a worker — including workers started after the switch.
 */
@Component({
    selector: 'externallibs-settings',
    templateUrl: './externallibs.settings.html'
})
export class ExternalLibsSettings implements OnInit {

    Providers = {
        ExcelProvider: null,
        PdfProvider: null,
        OcrProvider: null
    };
    AvailableExcelProviders = [];
    AvailablePdfProviders = [];
    AvailableOcrProviders = [];

    static GetSettingsEntry() {
        return {
            Caption: '@@ExternalLibs',
            ID: 'externallibs',
            Icon: 'file-box',
            Index: 60,
            Parent: 'settings',
            Security: {
                Name: 'evidanza.App.Shared.Security.PageSettingsRight',
                Value: 2
            },
            Content: ExternalLibsSettings
        };
    }

    constructor(private cdRef: ChangeDetectorRef, private service: ExternalLibsService) {
    }

    ngOnInit(): void {
        this.Refresh();
    }

    Refresh() {
        LayoutService.Loading.next(true);
        this.service.GetProviders().subscribe(x => {
            LayoutService.Loading.next(false);
            this.Apply(x);
        });
    }

    Save() {
        LayoutService.Loading.next(true);
        this.service.SetProviders(this.Providers).subscribe(x => {
            LayoutService.Loading.next(false);
            NotificationHelper.Success('@@ExternalLibsSaved', '@@Speichern');
            this.Apply(x);
        });
    }

    Reset() {
        MessageBoxHelper.ShowDialog(new TranslateFormatText('@@ExternalLibsResetQuestion'),
            new TranslateFormatText('@@Zuruecksetzen'), MessageBoxButtons.YesNo, MessageBoxIcon.Question).then(x => {
                if (x === MessageBoxResult.Yes) {
                    LayoutService.Loading.next(true);
                    this.service.ResetProviders().subscribe(result => {
                        LayoutService.Loading.next(false);
                        NotificationHelper.Success('@@ExternalLibsReset', '@@Zuruecksetzen');
                        this.Apply(result);
                    });
                }
            });
    }

    private Apply(result) {
        if (!result) {
            return;
        }
        this.Providers = {
            ExcelProvider: result.ExcelProvider,
            PdfProvider: result.PdfProvider,
            OcrProvider: result.OcrProvider
        };
        this.AvailableExcelProviders = result.AvailableExcelProviders || [];
        this.AvailablePdfProviders = result.AvailablePdfProviders || [];
        this.AvailableOcrProviders = result.AvailableOcrProviders || [];
        this.cdRef.detectChanges();
    }
}
